import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {
	activeServiceSelector,
	roundsSelector,
} from 'modules/admin-panel/pages/results/selectors/dashboard.selectors';
import { MONTH_YEAR } from 'modules/admin-panel/pages/results/utils/constants';
import './histogram-chart.styles.scss';

interface HistogramChartTooltipProps {
	title: string;
	value: string;
}

export const HistogramChartTooltip = React.forwardRef<
	HTMLDivElement,
	HistogramChartTooltipProps
>(({ title, value: respondents }, ref) => {
	const { t } = useTranslation('results');
	const activeService = useSelector(activeServiceSelector);
	const round = useSelector(roundsSelector);

	return round ? (
		<div ref={ref} className="histogram-listchart--tooltip">
			<ul className="histogram-listchart--tooltip__list">
				<h6 className="histogram-listchart--tooltip__list-head">{title}</h6>
				<h6 className="histogram-listchart--tooltip__list-head">
					{respondents} Ratings
				</h6>
			</ul>
		</div>
	) : null;
});
